import { useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useAuth } from '@web/walter-lib/auth'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import { getIsRoutePrivate } from '~utils/getIsRoutePrivate'
import { QueryParams } from '~constants/routes'

/**
 * Request sign in with the particular modal type (sign in, sign up, or auth required)
 */
function useRequestAuth() {
    const [searchParams] = useSearchParams()
    const authMode = searchParams.get(QueryParams.auth) || ''

    const { show: showAuthRequiredModal, hide } = useModal(ModalTypes.authRequired)
    const { isAuth } = useAuth()
    const { pathname } = useLocation()

    useEffect(() => {
        const isRoutePrivate = getIsRoutePrivate(pathname)

        if (!authMode && !isAuth && isRoutePrivate) {
            showAuthRequiredModal()
        }

        if (isAuth) {
            hide()
        }
    }, [isAuth, showAuthRequiredModal, pathname, authMode, hide])
}

export default useRequestAuth
